import { useEffect, useRef, useState } from "react";
import { prefersReducedMotion } from "./motion";

/**
 * Öğe görünür alana girince bir kez true olur. IntersectionObserver yoksa ya da
 * hareket azaltılmışsa baştan true döner; gözlemci hiç tetiklenmezse de
 * `fallbackMs` sonunda açılır, böylece içerik görünmez kalmaz.
 */
export default function useInView({ threshold = 0.25, rootMargin = "0px", fallbackMs = 4000 } = {}) {
  const ref = useRef(null);
  const [inView, setInView] = useState(
    () => typeof window === "undefined" || !("IntersectionObserver" in window) || prefersReducedMotion()
  );

  useEffect(() => {
    if (inView) return undefined;
    const node = ref.current;
    if (!node) return undefined;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setInView(true);
          observer.disconnect();
        }
      },
      { threshold, rootMargin }
    );
    observer.observe(node);
    const timer = window.setTimeout(() => setInView(true), fallbackMs);

    return () => {
      observer.disconnect();
      window.clearTimeout(timer);
    };
  }, [inView, threshold, rootMargin, fallbackMs]);

  return [ref, inView];
}
